module.exports = '3.13.2';



// WEBPACK FOOTER //
// ./src/version.js